import React, { useState, useEffect } from "react";
import { FaSearch, FaPrint, FaResearchgate, FaDollarSign, FaInfoCircle, FaCertificate } from "react-icons/fa";
import { Button, Table, Spinner, OverlayTrigger, Tooltip, Modal, Form } from "react-bootstrap";
import { get } from "../../services/Services";
import { jsPDF } from "jspdf";
import { useNavigate, useLocation } from "react-router-dom";
import autoTable from "jspdf-autotable";
import { FaMedal } from "react-icons/fa";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { FaUsers, FaChalkboardTeacher, FaCalculator } from "react-icons/fa";
import "./Fonts/Fashion-bolditalic.js";
import "./Fonts/CampanaScript.js";
import "./Fonts/GreatVibes-Regular-normal.js";
import { diploma_Base64 } from './Certificates/diploma_base64.js';
import "./Fonts/Amoresa-bolditalic.js";
import "./Fonts/Playball-Regular-bolditalic.js";
import "./Fonts/Pattaya-Regular-bolditalic.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward } from "@fortawesome/free-solid-svg-icons";

const Registrations = () => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalTime, setTotalTime] = useState(null); // Nueva variable para tiempo total
  const [finalObrasSchool, setFinalObrasSchool] = useState("");
  const location = useLocation();
  const { eventId, ConfigId, eventName, school } = location.state || {};
  const navigate = useNavigate();
  const [showFinalObrasModal, setShowFinalObrasModal] = useState(false);
  const [finalObras, setFinalObras] = useState([]);
  const [loadingFinalObras, setLoadingFinalObras] = useState(false);
  const [showCredentialsModal, setShowCredentialsModal] = useState(false);
  const [credentials, setCredentials] = useState([]);
  const [loadingCredentials, setLoadingCredentials] = useState(false);
  const [showCertModal, setShowCertModal] = useState(false);
  const [selectedRegistration, setSelectedRegistration] = useState(null);
  const [certType, setCertType] = useState({ participation: false, choreography: false });
  const [totalCertificates, setTotalCertificates] = useState(0);
  
  useEffect(() => {
  const fetchCertificates = async () => {
    try {
      const response = await get(`/api/academy/events/${ConfigId}/performances/awards`);
      const data = response.data || [];

      const total = data.reduce((acc, award) => acc + (award.countParticipants || 0), 0);
      setTotalCertificates(total);
    } catch (error) {
      console.error("Error al obtener certificados:", error);
    }
  };

  fetchCertificates();
}, [ConfigId]);

  useEffect(() => {
    if (ConfigId) {
      fetchRegistrations();
      fetchTotalTime(); // Llamar también a traer el tiempo total
    }
  }, [ConfigId]);

  const fetchRegistrations = async () => {
    try {
      setLoading(true);
      const response = await get(
        `/api/academy/events/${ConfigId}/registrations?page=0&size=1000&order_by=id`
      );
      setRegistrations(response.data.content || []);
    } catch (error) {
      setError("Error al cargar las inscripciones");
      console.error("Error al obtener inscripciones:", error);
    } finally {
      setLoading(false);
    }
  };

  // Nueva función para traer el tiempo total
  const fetchTotalTime = async () => {
    try {
      const response = await get(
        `/api/academy/events/${ConfigId}/performances/time`
      );
      setTotalTime(response.data.totalTime); // ✅ Guarda solo el string "08:53:00"
    } catch (error) {
      console.error("Error al obtener el tiempo total:", error);
    }
  };

 


  const handleViewPerformances = (registrationId, eventId, schoolId, school) => {
    navigate(`/eventorganization/managementperformances`, {
      state: { registrationId, eventId, schoolId, school },
    });
  };

  const handlePrintPerformances = async (registrationId, school, schoolId, eventId, eventName) => {
    try {
      const registration = await get(`/api/academy/events/registration/${registrationId}/performance?page=0&size=300`);
      const performances = registration.data.content || [];
      const userInfo = await get(`/api/academy/schools/${schoolId}`);

      const doc = new jsPDF("portrait");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginX = 14;
      const contentWidth = pageWidth - marginX * 2;
      let y = 20;

      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      const title = eventName || "Evento";
      const titleWidth = doc.getTextWidth(title);
      const titleX = (pageWidth - titleWidth) / 2;
      doc.text(title, titleX, y);
      y += 8;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      const schoolName = registration.data.school || school || "Escuela";
      const schoolLines = doc.splitTextToSize(schoolName, contentWidth);
      schoolLines.forEach(line => {
        const lineWidth = doc.getTextWidth(line);
        doc.text(line, (pageWidth - lineWidth) / 2, y);
        y += 6;
      });

      doc.setFont("helvetica", "normal");
      const responsible = `${userInfo.data.user?.name || ""} ${userInfo.data.user?.lastname || ""}`;
      const responsibleLines = doc.splitTextToSize(responsible, contentWidth);
      responsibleLines.forEach(line => {
        const lineWidth = doc.getTextWidth(line);
        doc.text(line, (pageWidth - lineWidth) / 2, y);
        y += 6;
      });

      y += 4;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("Acreditaciones de Obras", marginX, y);
      y += 10;

      performances.forEach((p, idx) => {
        const participantesCount = (p.participants || []).filter(part => part.type?.name === "Bailarín").length;
        const estimatedHeight = 20 + (participantesCount || 1) * 6;
        if (y + estimatedHeight > pageHeight - 20) {
          doc.addPage();
          y = 20;
        }

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        const obraTitulo = `${p.order || idx + 1}  Obra: ${p.name || "Sin nombre"}`;
        const obraLines = doc.splitTextToSize(obraTitulo, contentWidth);
        obraLines.forEach(line => {
          doc.text(line, marginX, y);
          y += 6;
        });

        const descripcion = `${p.modality?.name || ""} ${p.category?.name || ""} ${p.form?.name || ""}`;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        const descLines = doc.splitTextToSize(descripcion, contentWidth);
        descLines.forEach(line => {
          doc.text(line, marginX, y);
          y += 6;
        });

        const bailarines = (p.participants || [])
          .filter(part => part.type?.name === "Bailarín")
          .sort((a, b) => {
            const nameA = `${a.member?.surname || ""} ${a.member?.name || ""}`.toLowerCase();
            const nameB = `${b.member?.surname || ""} ${b.member?.name || ""}`.toLowerCase();
            return nameA.localeCompare(nameB);
          });
        if (bailarines.length > 0) {
          bailarines.forEach(b => {
            if (y + 6 > pageHeight - 20) {
              doc.addPage();
              y = 20;
            }
            const fullName = `${b.member?.surname || ""} ${b.member?.name || ""}`;
            const nameLines = doc.splitTextToSize(fullName, contentWidth / 2);
            nameLines.forEach(line => {
              doc.rect(marginX, y - 4, 4, 4);
              doc.text(line, marginX + 6, y);
              doc.text("Obs: _______________________", marginX + 100, y);
              y += 6;
            });
          });
        } else {
          doc.text("Sin participantes", marginX + 6, y);
          y += 6;
        }

        doc.setDrawColor(150);
        doc.line(marginX, y, pageWidth - marginX, y);
        doc.setDrawColor(0);
        y += 10;
      });
      toast.success("Archivo Generado Correctamente");
      doc.save(`acreditaciones_${registrationId}.pdf`);
    } catch (error) {
      console.error("Error al generar el PDF:", error);
    }
  };

  const handleGoToPayments = (eventRegistrationId, configId, school) => {
    navigate("/payments/managementpayments", {
      state: {
        eventRegistrationId,
        configId,
        school,
      },
    });
  };

  const handleGoToFinalObrasModal = async (eventRegistrationId, school) => {
    try {
      setLoadingFinalObras(true);
      setShowFinalObrasModal(true);
  
      const response = await get(
        `/api/academy/events/${ConfigId}/performances/awards?event_registration_id=${eventRegistrationId}`
      );
      setFinalObrasSchool(school);
      setFinalObras(response.data || []);
    } catch (error) {
      console.error("Error al obtener el orden final de obras:", error);
      setFinalObras([]);
    } finally {
      setLoadingFinalObras(false);
    }
  };
  
  const handleGeneratePDFFinalPerformances = () => {
    const doc = new jsPDF();

    // Título
    doc.setFontSize(16);
    doc.text(`Orden Final de Obras - ${finalObrasSchool}`, 14, 20);
  
    // Columnas
    const columns = [
      { header: "#", dataKey: "performanceOrder" },
      { header: "Obra", dataKey: "dancePerformance" },
      { header: "Modalidad", dataKey: "modality" },
      { header: "Categoría", dataKey: "category" },
      { header: "Forma", dataKey: "participationForm" },
    ];
  
    // Datos
    const rows = finalObras.map((obra) => ({
      performanceOrder: obra.performanceOrder,
      dancePerformance: obra.dancePerformance,
      modality: obra.modality,
      category: obra.category,
      participationForm: obra.participationForm,
    }));
  
    // ✅ Acá usamos autoTable desde la función importada
    autoTable(doc, {
      columns,
      body: rows,
      startY: 30,
    });
  
    // Guarda el PDF
    doc.save(`OrdenFinal_${finalObrasSchool}.pdf`);
  };

  const handleGoToCredentialsModal = async (eventRegistrationId, ConfigId) => {
    try {
      setLoadingCredentials(true);
      setShowCredentialsModal(true);

      const response = await get(
        `/api/academy/events/${ConfigId}/credentials?event_registration_id=${eventRegistrationId}`
      );
      setCredentials(response.data || []);
    } catch (error) {
      console.error("Error al obtener las credenciales:", error);
      setCredentials([]);
    } finally {
      setLoadingCredentials(false);
    }
  };

  const schedules = credentials[0]?.schedules || [];

  const totalParticipants = schedules.reduce((acc, item) => acc + item.countParticipants, 0);
  const totalChoreographers = schedules.reduce((acc, item) => acc + item.countPreparersChoreographers, 0);
  const grandTotal = totalParticipants + totalChoreographers;
  
 const handlePrintCertification = async (eventRegistrationId, schoolName, certType) => {
  try {
    let url = `https://ectech-software.com.ar/api/academy/events/${ConfigId}/performances/awards?event_registration_id=${eventRegistrationId}`;

    if (certType === 'choreography') {
      url += `&is_choreographed=true`;
    }
    
    const response = await get(url);
    const data = response.data;

    if (!Array.isArray(data) || data.length === 0) {
      alert("No hay datos disponibles para generar certificados.");
      return;
    }

    const eventResponse = await get(
      `https://ectech-software.com.ar/api/academy/events/${eventId}`
    );
    const eventInfo = eventResponse.data;
    const eventName = eventInfo?.name || "Nombre del evento";
    


    const formatDateLongSpanish = (dateStr) => {
  if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    // Si no es fecha válida en formato YYYY-MM-DD, devolvemos el texto tal cual
    return dateStr;
  }
  const [year, month, day] = dateStr.split("-");
  const localDate = new Date(`${year}-${month}-${day}T00:00:00`);
  
  return localDate.toLocaleDateString("es-ES", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
const eventEndDate = formatDateLongSpanish(eventInfo?.config?.eventEndDate || "Fecha no disponible");
    const eventCity = eventInfo?.config?.city.name || "";
    const eventCompetitionNumber = eventInfo?.config?.competitionNumber || "";
    const eventChoreographers = eventInfo?.config?.choreographers || "";

    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
    let pageCount = 0;

    

    data.forEach((performance) => {
      const {
        members,
        awards,
        modality,
        category,
        dancePerformance,
        choreographers,
        competitionNumber,
        city
      } = performance;

      

      if (!Array.isArray(awards) || awards.length === 0) return;

      if (certType === 'choreography') {
        // ✅ Solo premios que contengan "coreografía"
        awards
          .filter(a => a.name.toLowerCase().includes("coreografía"))
          .forEach((award) => {
            if (pageCount > 0) doc.addPage();
            doc.addImage(diploma_Base64, 'PNG', 0, 0, 297, 210); // A4 landscape
            const nameToShow = Array.isArray(choreographers) && choreographers.length > 0
              ? choreographers.join(" y ")
              : "Nombre del Coreógrafo";
            //Certificamos que 
            doc.setFont("cambria", "normal");
            doc.setFontSize(24);
            doc.text("Certificamos a", 148, 45, { align: "center" });

            //Nombre de alumno - profesor - preparador
            doc.setFont('Playball-Regular', 'bolditalic');
            doc.setFontSize(50);
            doc.setTextColor('AB8E5B');
            doc.text(nameToShow.trim(), 148, 65, { align: "center" });

            //participo del 
            doc.setFont("cambria", "normal");
            doc.setFontSize(23);
            doc.setTextColor('#000000');
            doc.text(`Participó del ${competitionNumber} Certamen`, 148, 80, { align: "center" });

            //Nombre del evento 
            doc.setFont('Playball-Regular', 'bolditalic');
            doc.setFontSize(58);
            doc.text(`${eventName}`, 148, 100, { align: "center" });

            //modalidad y obra
            doc.setFont("cambria", "normal");
            doc.setFontSize(23);
            doc.text(`Modalidad ${modality || ""} - ${category || ""}`,148,115,{ align: "center" });
            doc.text(`con la obra: ${dancePerformance || "Obra sin título"}`, 148, 126, {align: "center",});

           //Jurados
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`GUSTAVO BERTUOL`,60,168,{ align: "center" });
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`YAMILA MASUR`,125,170,{ align: "center" });
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`MARCELA MANZANO`,190,170,{ align: "center" });
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`IRUPÉ PEREIRA`,245,168,{ align: "center" });       

            //Premio
            doc.setFont('Playball-Regular', 'bolditalic');
            doc.setFontSize(36);
            doc.text(award.name, 148, 144, { align: "center" });

            //Ciudad y fecha
            doc.setFont("cambria", "normal");
            doc.setFontSize(14);
            doc.text(`${eventCity}, ${eventEndDate}`, 148, 200, {
              align: "center",
            });

            pageCount++;
          });
      }
      else if (certType === 'preparer') {
  const award = awards.find(a => !a.name.toLowerCase().includes("coreografía"));
  if (!award || !Array.isArray(performance.preparers) || performance.preparers.length === 0) return;

  performance.preparers.forEach((preparer) => {
    if (typeof preparer !== "string") return;

    if (pageCount > 0) doc.addPage();
    doc.addImage(diploma_Base64, 'PNG', 0, 0, 297, 210); // A4 landscape
    //Certificamos que 
    doc.setFont("cambria", "normal");
    doc.setFontSize(24);
    doc.text("Certificamos que", 148, 45, { align: "center" });

    //Profesor - Preparador - Alumno
    doc.setFont('Playball-Regular', 'bolditalic');
    doc.setFontSize(50);
    doc.setTextColor('AB8E5B');
    doc.text(`Prof. ${preparer.trim()}`, 148, 65, { align: "center" });

    //Participó del 
    doc.setFont("cambria", "normal");
    doc.setFontSize(23);
    doc.setTextColor('#000000');
    doc.text(`Participó del ${competitionNumber} Certamen`, 148, 80, { align: "center" });

    //Nombre del evento
    doc.setFont('Playball-Regular', 'bolditalic');
    doc.setFontSize(58);
    doc.text(`${eventName}`, 148, 100, { align: "center" });

    //Modalidad  - obra
    doc.setFont("cambria", "normal");
    doc.setFontSize(23);
    doc.text(`Modalidad ${modality || ""} - Categoría ${category || ""}`,148,115,{ align: "center" });
    doc.text(`con la obra: ${dancePerformance || "Obra sin título"}`, 148, 126, {align: "center",});

    //Jurados
    doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`GUSTAVO BERTUOL`,60,168,{ align: "center" });
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`YAMILA MASUR`,125,170,{ align: "center" });
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`MARCELA MANZANO`,190,170,{ align: "center" });
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`IRUPÉ PEREIRA`,245,168,{ align: "center" });   

    //Premios
    doc.setFont('Playball-Regular', 'bolditalic');
    doc.setFontSize(36);
    doc.text(award.name, 148, 144, { align: "center" });

    //Ciudad y fecha
    doc.setFont("cambria", "normal");
    doc.setFontSize(14);
    doc.text(`${eventCity}, ${eventEndDate}`, 148, 200, {
      align: "center",
    });

    pageCount++;
  });
}

      else {
        if (!Array.isArray(members) || members.length === 0) return;

        // ❗ Solo usamos el primer premio que NO sea de coreografía
        const award = awards.find(a => !a.name.toLowerCase().includes("coreografía"));
        if (!award) return;

        members.forEach((member) => {
          if (typeof member !== "string") return;

          if (pageCount > 0) doc.addPage();
          doc.addImage(diploma_Base64, 'PNG', 0, 0, 297, 210); // A4 landscape
          
          //certificamos que 
          doc.setFont("cambria", "normal");
          doc.setFontSize(24);
          doc.text("Certificamos que", 148, 45, { align: "center" });

          //Profesores - Alumnos - preparadores
          doc.setFont('Playball-Regular', 'bolditalic');
          doc.setFontSize(50);
          doc.setTextColor('AB8E5B');
          doc.text(member.trim(), 148, 65, { align: "center" });

          //Participo del 
          doc.setFont("cambria", "normal");
          doc.setFontSize(23);
          doc.setTextColor('#000000');
          doc.text(`Participó del ${eventCompetitionNumber} Certamen`, 148, 80, { align: "center" });

          //Evento
          doc.setFont('Playball-Regular', 'bolditalic');
          doc.setFontSize(58);
          doc.text(`${eventName}`, 148, 100, { align: "center" });

          //Modalidad - con la obra
          doc.setFont("cambria", "normal");
          doc.setFontSize(23);
          doc.text(`En la modalidad ${modality || ""} ${category ? `${category}` : ""}`,148,115,{ align: "center" });
          doc.text(`con la obra: ${dancePerformance || "Obra sin título"}`, 148, 126,{align: "center",});

          //Jurados
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`GUSTAVO BERTUOL`,60,168,{ align: "center" });
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`YAMILA MASUR`,125,170,{ align: "center" });
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`MARCELA MANZANO`,190,170,{ align: "center" });
            doc.setFont("cambria", "normal");
            doc.setFontSize(12);
            doc.text(`IRUPÉ PEREIRA`,245,168,{ align: "center" });     

          //premio
          doc.setFont('Playball-Regular', 'bolditalic');
          doc.setFontSize(36);
          doc.text(award.name, 148, 144, { align: "center" });

          //Ciudad - fecha
          doc.setFont("cambria", "normal");
          doc.setFontSize(14);
          doc.text(`${eventCity}, ${eventEndDate}`, 148, 200, {
            align: "center",
          });

          pageCount++;
        });
      }
      
    });

    doc.save("certificados_personalizados.pdf");
  } catch (error) {
    console.error("Error al generar certificados:", error);
    alert("Error al generar certificados: " + error.message);
  }
};

const handlePrintregistrations = async (ConfigId) => {
  try {
    const response = await get(
      `https://ectech-software.com.ar/api/academy/events/${ConfigId}/registrations?page=0&size=1000&order_by=id`
    );
    
    const data = response.data;
    const registrations = data.content || [];

    const doc = new jsPDF();

    // Título centrado
    const title = "Listado de Escuelas Registradas";
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = doc.getTextWidth(title);
    const x = (pageWidth - textWidth) / 2;
    doc.setFontSize(16);
    doc.text(title, x, 20);

    // Columnas y filas
    const columns = ["Registro", "Escuela", "Acreditaciones", "Credenciales", "Certificados", "Observaciones"];
    const rows = registrations.map((reg) => [
      reg.id,
      reg.school,
      "", // Acreditaciones
      "", // Credenciales
      "", // Certificados
      "", // Observaciones
    ]);

    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 30,
      styles: {
        fontSize: 9,
        cellPadding: 3,
        lineWidth: 0.1,
        lineColor: 0,
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: 255,
        halign: "center",
      },
    });

    doc.save("registraciones_escuelas.pdf");
  } catch (error) {
    console.error("Error al generar el PDF:", error);
  }
};







  

  return (
    <div className="container mt-6 text-center">
      <h1 className="text-center">Inscripciones</h1>
      <div className="text-center py-3">
        <Button className="me-1 small Primary sm " onClick={() => handlePrintregistrations(ConfigId)}>
                  <FaPrint /> Imprimir Inscripciones
        </Button>
      </div>
      {loading ? (
  <div className="text-center">
    <Spinner animation="border" />
    <p>Cargando inscripciones…</p>
  </div>
) : error ? (
  <div className="alert alert-danger">{error}</div>
) : (
  // 🚀 Aquí agregamos el scroll
  <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
    <Table striped bordered hover responsive>
      <thead className="table-primary text-center">
        <tr>
          <th>Registro N°</th>
          <th>Escuela</th>
          <th>Obras</th>
          <th>Seminarios / Congresos</th>
          <th>Preparadores</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody className="text-center">
        {registrations.map((reg) => (
          <tr key={reg.id}>
            <td>{reg.id}</td>
            <td>{reg.school}</td>
            <td>{reg.performanceCount}</td>
            <td>{reg.courseCount}</td>
            <td>
              {reg.coaches.map((coach, index) => (
                <div key={index} className="mb-1">{coach}</div>
              ))}
            </td>
            <td>
              <OverlayTrigger placement="top" overlay={<Tooltip>Ver Obras</Tooltip>}>
                <Button variant="success" size="sm" className="me-1 small" onClick={() => handleViewPerformances(reg.id, eventId, reg.schoolId, reg.school)}>
                  <FaSearch />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger placement="top" overlay={<Tooltip>Imprimir Acreditaciones</Tooltip>}>
                <Button variant="warning" size="sm" className="me-1 small" onClick={() => handlePrintPerformances(reg.id, reg.school, reg.schoolId, eventId, eventName)}>
                  <FaPrint />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger placement="top" overlay={<Tooltip>Credenciales</Tooltip>}>
                <Button variant="primary" size="sm" className="me-1 small" onClick={() => handleGoToCredentialsModal(reg.id, ConfigId)}>
                  <FaResearchgate />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger placement="top" overlay={<Tooltip>Pagos</Tooltip>}>
                <Button
                  variant="danger"
                  size="sm"
                  className="me-1 small"
                  onClick={() => handleGoToPayments(reg.id, ConfigId, reg.school)}
                >
                  <FaDollarSign />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger placement="top" overlay={<Tooltip>Orden Final de Obras</Tooltip>}>
                <Button
                  variant="dark"
                  size="sm"
                  className="me-1 small"
                  onClick={() => handleGoToFinalObrasModal(reg.id, reg.school)}
                >
                  <FaInfoCircle />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger placement="top" overlay={<Tooltip>Impresión de Certificados</Tooltip>}>
                <Button
                  variant="success"
                  size="sm"
                  className="me-1 small"
                  onClick={() => {
                    setSelectedRegistration({ id: reg.id, school: reg.school });
                    setShowCertModal(true);
                  }}
                >
                  <FaCertificate />
                </Button>
              </OverlayTrigger>
            </td>
          </tr>
        ))}

        {/* 🔥 Fila final mostrando el tiempo total */}
        {totalTime && (
          <tr className="table-secondary">
            <td colSpan="6" className="text-center fw-bold fs-5 py-3">
              🕒 Tiempo total del Evento: <span className="text-primary">{totalTime} hs</span>
            </td>
          </tr>
        )}
        {totalCertificates && (
          <tr className="table-secondary">
            <td  colSpan="6" className="text-center fw-bold fs-5 py-3">
              <FontAwesomeIcon icon={faAward} className="me-2 text-danger"/>
              Cantidad Estimada de certificados: <span className="text-danger">{totalCertificates}</span>
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
)}


      <Modal show={showFinalObrasModal} onHide={() => setShowFinalObrasModal(false)} size="lg" centered>
  <Modal.Header closeButton>
  <Modal.Title>Orden Final de: {finalObrasSchool}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {loadingFinalObras ? (
      <div className="text-center">
        <Spinner animation="border" />
        <p>Cargando datos…</p>
      </div>
    ) : finalObras.length === 0 ? (
      <p>No se encontraron obras.</p>
    ) : (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Obra</th>
            <th>Modalidad</th>
            <th>Categoría</th>
            <th>Forma</th>
           
          </tr>
        </thead>
        <tbody>
          {finalObras.map((obra, idx) => (
            <tr key={obra.performanceOrder}>
              <td>{obra.performanceOrder}</td>
              <td>{obra.dancePerformance}</td>
              <td>{obra.modality}</td>
              <td>{obra.category}</td>
              <td>{obra.participationForm}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    )}
  </Modal.Body>
  <Modal.Footer>
  <Button variant="secondary" onClick={() => setShowFinalObrasModal(false)}>
    Cerrar
  </Button>
  <Button variant="success" onClick={handleGeneratePDFFinalPerformances}>
    Descargar PDF
  </Button>
</Modal.Footer>
</Modal>
      <Modal show={showCredentialsModal} onHide={() => setShowCredentialsModal(false)} size="lg" centered>
  <Modal.Header closeButton style={{ backgroundColor: "#343a40", color: "white" }}>
    <Modal.Title>🎓 Credenciales de Inscripción</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {loadingCredentials ? (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Cargando credenciales…</p>
      </div>
    ) : credentials.length === 0 ? (
      <div className="text-center py-3">
        <p className="text-muted">No se encontraron credenciales.</p>
      </div>
    ) : (
      <>
        <h5 className="text-center mb-4 text-primary">
          🏫 {credentials[0].school}
        </h5>

        <Table bordered hover responsive className="text-center align-middle shadow-sm">
          <thead style={{ backgroundColor: "#007bff", color: "white" }}>
            <tr>
              <th><FaUsers /> Participantes</th>
              <th><FaChalkboardTeacher /> Preparadores / Coreógrafos</th>
              <th><FaCalculator /> Total General</th>
              
            </tr>
          </thead>
          <tbody>
            <tr style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              <td>{credentials[0].countParticipants}</td>
              <td>{credentials[0].countPreparersChoreographers}</td>
              <td style={{ backgroundColor: "#28a745", color: "white" }}>
                {credentials[0].countParticipants + credentials[0].countPreparersChoreographers}
              </td>
            </tr>
          </tbody>
        </Table>
      </>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="outline-secondary" onClick={() => setShowCredentialsModal(false)}>
      Cerrar
    </Button>
  </Modal.Footer>
</Modal>
<Modal show={showCertModal} onHide={() => setShowCertModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Seleccionar tipo de certificado</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Check
        type="checkbox"
        label="Por participación"
        checked={certType.participation}
        onChange={(e) =>
          setCertType((prev) => ({ ...prev, participation: e.target.checked }))
        }
      />
      <Form.Check
        type="checkbox"
        label="Por coreografía"
        checked={certType.choreography}
        onChange={(e) =>
          setCertType((prev) => ({ ...prev, choreography: e.target.checked }))
        }
      />
      <Form.Check
        type="checkbox"
        label="Para Maestros Preparadores"
        checked={certType.preparer}
        onChange={(e) =>
          setCertType((prev) => ({ ...prev, preparer: e.target.checked }))
        }
      />
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowCertModal(false)}>
      Cancelar
    </Button>
    <Button
  variant="primary"
  onClick={() => {
    if (selectedRegistration) {
      if (certType.participation) {
        handlePrintCertification(selectedRegistration.id, selectedRegistration.school, 'participation');
      }
      if (certType.choreography) {
        handlePrintCertification(selectedRegistration.id, selectedRegistration.school, 'choreography');
      }
      if (certType.preparer) {
        handlePrintCertification(selectedRegistration.id, selectedRegistration.school, 'preparer');
      }
    }
    setShowCertModal(false);
    setCertType({ participation: false, choreography: false, preparer: false });
  }}
>
  Generar
</Button>

  </Modal.Footer>
</Modal>



{/* ToastContainer */}
<ToastContainer 
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />


    </div>
  );
};

export default Registrations;
